import {ImageGalleryModal} from "../Modals/ImageGalleryModal"
import React from "react"
import classNames from "classnames"
import {kebabCase, startCase} from "lodash"
import {RotationDegrees} from "../../utilities/imageOrientation"

interface CheckImageModalProps {
	frontImage: JSX.Element
	backImage: JSX.Element
	status: string
	id: string
	closeModal: () => void
	initialRotations?: RotationDegrees[]
}

function CheckImageModalHeader({id, status}: {id: string; status: string}) {
	return (
		<div className="check-deposit-image-modal-header">
			<div className="check-deposit-image-modal-header-id"># {id}</div>

			<div className={classNames("check-deposit-status", kebabCase(status))}>{startCase(status)}</div>
		</div>
	)
}

export function FrontCheckImageModal({
	frontImage,
	backImage,
	closeModal,
	id,
	status,
	initialRotations,
}: CheckImageModalProps) {
	return (
		<ImageGalleryModal
			close={closeModal}
			gallery={[frontImage, backImage]}
			description={["Front Side", "Back Side"]}
			header={<CheckImageModalHeader id={id} status={status} />}
			initialRotations={initialRotations}
		/>
	)
}

export function BackCheckImageModal({
	backImage,
	frontImage,
	closeModal,
	id,
	status,
	initialRotations,
}: CheckImageModalProps) {
	return (
		<ImageGalleryModal
			close={closeModal}
			gallery={[backImage, frontImage]}
			description={["Back Side", "Front Side"]}
			header={<CheckImageModalHeader id={id} status={status} />}
			initialRotations={initialRotations}
		/>
	)
}
